import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import o, { createContext as H, useContext as E, useEffect as m, useState as u } from "react";
import { createPortal as g } from "react-dom";
import { useDisposables as h } from '../hooks/use-disposables.js';
import { objectToFormEntries as x } from '../utils/form.js';
import { compact as y } from '../utils/render.js';
import { Hidden as l, HiddenFeatures as d } from './hidden.js';
let f = H(null);
function W(t) {
  let [e, r] = u(null);
  return o.createElement(f.Provider, {
    value: {
      target: e
    }
  }, t.children, o.createElement(l, {
    features: d.Hidden,
    ref: r
  }));
}
function c(_ref) {
  let {
    children: t
  } = _ref;
  let e = E(f);
  if (!e) return o.createElement(o.Fragment, null, t);
  let {
    target: r
  } = e;
  return r ? g(o.createElement(o.Fragment, null, t), r) : null;
}
function j(_ref2) {
  let {
    data: t,
    form: e,
    disabled: r,
    onReset: n,
    overrides: F
  } = _ref2;
  let [i, a] = u(null),
    p = h();
  return m(() => {
    if (n && i) return p.addEventListener(i, "reset", n);
  }, [i, e, n]), o.createElement(c, null, o.createElement(C, {
    setForm: a,
    formId: e
  }), x(t).map(_ref3 => {
    let [s, v] = _ref3;
    return o.createElement(l, _objectSpread({
      features: d.Hidden
    }, y(_objectSpread({
      key: s,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      form: e,
      disabled: r,
      name: s,
      value: v
    }, F))));
  }));
}
function C(_ref4) {
  let {
    setForm: t,
    formId: e
  } = _ref4;
  return m(() => {
    if (e) {
      let r = document.getElementById(e);
      r && t(r);
    }
  }, [t, e]), e ? null : o.createElement(l, {
    features: d.Hidden,
    as: "input",
    type: "hidden",
    hidden: !0,
    readOnly: !0,
    ref: r => {
      if (!r) return;
      let n = r.closest("form");
      n && t(n);
    }
  });
}
export { j as FormFields, W as FormFieldsProvider, c as HoistFormFields };